import { Box } from "@mui/material";
import type { HeaderProps } from "react-big-calendar";

interface CustomWeekHeaderProps extends HeaderProps {
  className: string;
}

export const CustomWeekHeader = ({ label, className }: CustomWeekHeaderProps) => {
  return <Box className={className}>{label}</Box>;
};
